import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CmsserviceService } from 'src/app/common-cms-service/cmsservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-gcse-tests',
  templateUrl: './gcse-tests.component.html',
  styleUrls: ['./gcse-tests.component.css'],
  standalone: false
})
export class GcseTestsComponent implements OnInit, OnDestroy {

  title = 'GCSE Mock Test Calendar';

  filters: any = {
    categoryId: null,
    pattern: null,
    mode: null,
    month: null,
    center: null,
    search: ''
  };

  months = [
    { label: 'January', value: 1 },
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 }
  ];

  categories: any[] = [];
  gcseCategories: any[] = [];

  patterns: string[] = ['AQA', 'OCR', 'Edexcel'];

  patternTypes = [
    { type_id: 'AQA', type: 'AQA' },
    { type_id: 'OCR', type: 'OCR' },
    { type_id: 'Edexcel', type: 'Edexcel' }
  ];

  centers: string[] = [];

  allTests: any[] = [];
  testList: any[] = [];

  visibleCount = 12;

  openFaq: number | null = null;

  private ngUnsubscribe = new Subject<void>();

  private preselectCategoryId: number | null = null;

  private shouldAutoScroll = false;

  whyCards = [
    {
      title: 'Real Exam Environment',
      text: 'Students experience actual GCSE-style exam conditions.',
      icon: '📘'
    },
    {
      title: 'Detailed Feedback',
      text: 'Get personalised performance analysis and improvement guidance.',
      icon: '📊'
    },
    {
      title: 'Expert Teachers',
      text: 'Papers reviewed by experienced GCSE subject specialists.',
      icon: '🎓'
    },
    {
      title: 'Fast Results',
      text: 'Receive e-results and cohort reports quickly.',
      icon: '⚡'
    }
  ];

  features = [
    {
      title: 'Personalised Feedback',
      text: 'Understand strengths and weaknesses clearly.',
      icon: '📝'
    },
    {
      title: 'Past Papers Included',
      text: 'Extra revision material for additional practice.',
      icon: '📚'
    },
    {
      title: 'Doubt Clearing Session',
      text: 'Resolve mistakes and improve exam strategy.',
      icon: '💡'
    },
    {
      title: 'Cohort Performance Report',
      text: 'Compare performance against peers.',
      icon: '📈'
    }
  ];

  testimonials = [
    {
      name: 'Sarah',
      location: 'London',
      text: 'The mock exams gave my child real confidence before GCSEs.'
    },
    {
      name: 'Ahmed',
      location: 'Essex',
      text: 'Detailed reports helped identify weak areas quickly.'
    },
    {
      name: 'Priya',
      location: 'Birmingham',
      text: 'Excellent organisation and realistic exam conditions.'
    }
  ];

  faqs = [
    {
      q: 'How long are the mock exams?',
      a: 'The duration matches the actual GCSE exam timings.'
    },
    {
      q: 'Which exam boards are covered?',
      a: 'AQA, OCR and Edexcel formats are available.'
    },
    {
      q: 'Do students receive feedback?',
      a: 'Yes, every student receives detailed personalised feedback.'
    },
    {
      q: 'Are online sessions available?',
      a: 'Yes, selected subjects are available online.'
    }
  ];

  constructor(
    private router: ActivatedRoute,
    private titleService: Title,
    private categoryProduct: CmsserviceService,
    private route: Router,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {

    this.titleService.setTitle(this.title);

    this.fetchTests();

    this.router.queryParams.subscribe(params => {

      if (params['category']) {

        const cid = Number(params['category']);

        if (!isNaN(cid)) {
          this.preselectCategoryId = cid;
          this.filters.categoryId = cid;
        }
      }

      if (params['scroll'] === 'calendar-section') {
        this.shouldAutoScroll = true;
      }

    });

    this.autoScorll();

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // ============================================================
  // FETCH TESTS
  // ============================================================

  fetchTests() {

    $('.loader-bg').fadeIn();

    var self = this;

    this.categoryProduct.getTestFilters()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(function(res: any) {

        self.categories =
          (res && res.data && res.data.category)
            ? res.data.category
            : [];

        self.gcseCategories = self.extractGcseCategories(self.categories);

        var catIds = [];

        for (var i = 0; i < self.gcseCategories.length; i++) {
          catIds.push(String(self.gcseCategories[i].category_id));
        }

        var formData: any = {
          release: 'new',
          page: 1,
          user_id: +localStorage.getItem('userid') || 0,
          course: [],
          category: catIds,
          type: [],
          search: self.filters.search || '',
          exam_type: self.mapExamType(self.filters.mode)
        };

        self.allTests = [];

        self.fetchPage(formData);

      }, function() {
        $('.loader-bg').fadeOut();
      });

  }

  private fetchPage(formData: any) {

    var self = this;

    this.categoryProduct.getTestList(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(function(res: any) {

        var chunk = (res && res.data) ? res.data : [];

        var extra =
          (res && res.extra && res.extra.extraCount)
            ? res.extra.extraCount
            : 0;

        for (var i = 0; i < chunk.length; i++) {
          self.allTests.push(chunk[i]);
        }

        if (extra > 0) {
          formData.page = formData.page + 1;
          self.fetchPage(formData);
          return;
        }

        $('.loader-bg').fadeOut();

        self.centers = self.buildCenters(self.allTests);

        self.testList = self.applyLocalFilters(self.allTests);

        self.ref.detectChanges();

      }, function() {
        $('.loader-bg').fadeOut();
      });

  }

  // ============================================================
  // APPLY FILTERS
  // ============================================================

  applyFilters() {
    this.testList = this.applyLocalFilters(this.allTests);
    this.ref.detectChanges();
  }

  resetFilters() {

    this.filters = {
      categoryId: null,
      pattern: null,
      mode: null,
      month: null,
      center: null,
      search: ''
    };

    this.applyFilters();

  }

  private applyLocalFilters(source: any[]): any[] {

    var list = source.slice(0);

    // CATEGORY

    if (this.filters.categoryId) {

      var selectedCategory =
        (this.filters.categoryId + '')
          .toLowerCase()
          .trim();

      var tmpCat: any[] = [];

      for (var i = 0; i < list.length; i++) {

        var cat = '';

        if (list[i].category) {
          cat = (list[i].category + '').toLowerCase().trim();
        } else if (list[i].category_name) {
          cat = (list[i].category_name + '').toLowerCase().trim();
        }

        if (cat.indexOf(selectedCategory) !== -1) {
          tmpCat.push(list[i]);
        }

      }

      list = tmpCat;
    }

    // PATTERN

    if (this.filters.pattern) {

      var p = (this.filters.pattern + '').toLowerCase();

      var tmp2: any[] = [];

      for (var j = 0; j < list.length; j++) {

        var nm =
          ((list[j].test_name || '') + '')
            .toLowerCase();

        if (nm.indexOf(p) !== -1) {
          tmp2.push(list[j]);
        }

      }

      list = tmp2;
    }

    // MODE

    if (this.filters.mode && this.filters.mode !== 'Both') {

      var mode = (this.filters.mode + '').toLowerCase();

      var tmp3: any[] = [];

      for (var k = 0; k < list.length; k++) {

        var et =
          ((list[k].exam_type || '') + '')
            .toLowerCase();

        if (
          mode.indexOf('online') !== -1 &&
          et.indexOf('online') !== -1
        ) {
          tmp3.push(list[k]);
        }

        else if (
          (
            mode.indexOf('face') !== -1 ||
            mode.indexOf('classroom') !== -1
          ) &&
          et.indexOf('classroom') !== -1
        ) {
          tmp3.push(list[k]);
        }

      }

      list = tmp3;
    }

    // MONTH

    if (this.filters.month) {

      var m = this.filters.month;

      var tmp4: any[] = [];

      for (var a = 0; a < list.length; a++) {

        var dateStr =
          (list[a].test_date || '').trim();

        if (dateStr.indexOf('-') !== -1) {

          var parts = dateStr.split('-');

          var start = this.parseDate(parts[0]);

          var end = this.parseDate(parts[1]);

          if (start && end) {

            if (
              (start.getMonth() + 1) === m ||
              (end.getMonth() + 1) === m
            ) {
              tmp4.push(list[a]);
            }

          }

        } else {

          var d = this.parseDate(dateStr);

          if (d && (d.getMonth() + 1) === m) {
            tmp4.push(list[a]);
          }

        }

      }

      list = tmp4;
    }

    // CENTER

    if (this.filters.center) {

      var c =
        (this.filters.center + '')
          .toLowerCase();

      var tmp5: any[] = [];

      for (var b = 0; b < list.length; b++) {

        var loc =
          ((list[b].location || '') + '')
            .toLowerCase();

        var al =
          ((list[b].all_location || '') + '')
            .toLowerCase();

        if (
          loc.indexOf(c) !== -1 ||
          al.indexOf(c) !== -1
        ) {
          tmp5.push(list[b]);
        }

      }

      list = tmp5;
    }

    // SEARCH

    if (
      this.filters.search &&
      this.filters.search.replace(/\s+/g, '') !== ''
    ) {

      var s =
        (this.filters.search + '')
          .toLowerCase();

      var tmp6: any[] = [];

      for (var z = 0; z < list.length; z++) {

        var blob =
          JSON.stringify(list[z]).toLowerCase();

        if (blob.indexOf(s) !== -1) {
          tmp6.push(list[z]);
        }

      }

      list = tmp6;
    }

    // SORT

    list.sort((a: any, b: any) => {

      var da = this.extractFirstDate(a.test_date);

      var db = this.extractFirstDate(b.test_date);

      if (!da && !db) return 0;

      if (!da) return 1;

      if (!db) return -1;

      return da.getTime() - db.getTime();

    });

    return list;

  }

  // ============================================================
  // HELPERS
  // ============================================================

  private parseDate(dateStr: string): Date | null {

    var clean = dateStr
      .replace(/\s+/g, '')
      .replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');

    var d = new Date(clean);

    return isNaN(d.getTime()) ? null : d;

  }

  private extractFirstDate(range: string): Date | null {

    if (!range) return null;

    var part = range.split('-')[0].trim();

    return this.parseDate(part);

  }

  private extractGcseCategories(all: any[]): any[] {

    var out: any[] = [];

    for (var i = 0; i < (all || []).length; i++) {

      var nm =
        ((all[i].category_name || '') + '')
          .toLowerCase();

      if (nm.indexOf('gcse') !== -1) {
        out.push(all[i]);
      }

    }

    return out;

  }

  private mapExamType(mode: any): string {

    var m = (mode || '').toLowerCase();

    if (m.indexOf('online') !== -1) {
      return 'online';
    }

    if (
      m.indexOf('face') !== -1 ||
      m.indexOf('classroom') !== -1
    ) {
      return 'classroom';
    }

    return 'both';

  }

  private buildCenters(list: any[]): string[] {

    var set: any = {};

    for (var i = 0; i < (list || []).length; i++) {

      var v =
        ((list[i].all_location || list[i].location || '') + '')
          .trim();

      if (v) {
        set[v] = true;
      }

    }

    var out: string[] = [];

    for (var k in set) {
      if (set.hasOwnProperty(k)) {
        out.push(k);
      }
    }

    out.sort();

    return out;

  }

  trimChar(str: string, length: number = 30) {

    if (!str) return '';

    return str.length < length
      ? str
      : str.substring(0, length) + '...';

  }

  // ============================================================
  // DATE METHODS
  // ============================================================

  isRangeDate(date: string): boolean {

    if (!date) return false;

    return date.indexOf('-') !== -1;

  }

  hasDate(date: string): boolean {
    return !!date && date.trim() !== '';
  }

  getDateDay(date: string): string {

    var d = this.extractFirstDate(date);

    if (!d) return '--';

    return ('0' + d.getDate()).slice(-2);

  }

  getDateMon(date: string): string {

    var d = this.extractFirstDate(date);

    if (!d) return '--';

    return d.toLocaleString('default', {
      month: 'short'
    });

  }

  getDateYr(date: string): string {

    var d = this.extractFirstDate(date);

    if (!d) return '--';

    return d.getFullYear().toString();

  }

  // ============================================================
  // SUBJECT TAG
  // ============================================================

  getSubjectTag(name: string): any {

    var n = (name || '').toLowerCase();

    if (n.indexOf('math') !== -1) {
      return {
        label: 'Maths',
        cls: 'maths'
      };
    }

    if (n.indexOf('english') !== -1) {
      return {
        label: 'English',
        cls: 'english'
      };
    }

    if (
      n.indexOf('biology') !== -1 ||
      n.indexOf('chemistry') !== -1 ||
      n.indexOf('physics') !== -1 ||
      n.indexOf('science') !== -1
    ) {
      return {
        label: 'Science',
        cls: 'science'
      };
    }

    return {
      label: 'GCSE',
      cls: 'default'
    };

  }

  // ============================================================
  // UI METHODS
  // ============================================================

  filterByCentre(center: string) {

    this.filters.center = center;

    this.applyFilters();

    setTimeout(() => {
      this.scrollToCalendar();
    }, 100);

  }

  setMode(mode: any) {

    this.filters.mode = mode;

    this.applyFilters();

  }

  loadMore() {
    this.visibleCount += 12;
  }

  toggleFaq(index: number) {

    if (this.openFaq === index) {
      this.openFaq = null;
    } else {
      this.openFaq = index;
    }

  }

  // ============================================================
  // SCROLL
  // ============================================================

  autoScorll() {

    if (this.shouldAutoScroll) {

      setTimeout(() => {
        this.scrollToCalendar();
      }, 200);

    }

  }

  scrollToCalendar() {

    const offerElement =
      document.getElementById('calendar-section');

    if (offerElement) {

      offerElement.scrollIntoView({
        behavior: 'smooth'
      });

    }

  }

  // ============================================================
  // DOWNLOAD
  // ============================================================

  downloadCalendar() {

    window.location.href =
      'https://drive.google.com/uc?export=download&id=1m8a4_-XWwFM8iewa57qH5j8Mx6n9vl2J';

  }

  downloadSchedule() {
    this.downloadCalendar();
  }

}